module.exports = __webpack_public_path__ + "08f4e28cd276b3dec16462f74fef46e7.mp3";